import { useEffect, useState } from 'react'
import { Image } from 'expo-image'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import { avatarPlaceholder } from '../customUtils/Constants'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'

export const UserAvatarWeb = ({ avatarUrl, style }) => {
    const __UserAvatarCache = new Map()
    const [avatar, setAvatar] = useState(avatarPlaceholder)
    
    useEffect(() => {
        let mounted = true
        const key = avatarUrl
        
        if (!key) {
            setAvatar(avatarPlaceholder)
            return
        }
        
        // Si ya es una URL completa (empieza con http), usarla directamente
        const isFullUrl = key.startsWith('http://') || key.startsWith('https://')
        
        if (isFullUrl) {
            setAvatar(key)
            return
        }
        
        // Si no es URL completa, es un filename de S3, procesar normalmente
        const hit = __UserAvatarCache.get(key)
        
        if (hit) {
            setAvatar(hit)
            return
        }
        
        // 1) TTL cache persistente
        getAvatarFromCache(key)
            .then((cached) => {
                if (!mounted) return
                if (cached) {
                    setAvatar(cached)
                    return true
                }
                return false
            })
            .then((servedFromCache) => {
                if (servedFromCache) return
                // 2) Resolver filename a URL desde S3
                getImageStogeUrl(key).then(async (url) => {
                    if (!mounted) return
                    if (url) {
                        setAvatar(url)
                        try {
                            await setAvatarInCache(key, url)
                        } catch (e) {}
                    }
                })
            })
        
        return () => {
            mounted = false
        }
    }, [avatarUrl])
    
    return <Image style={style} source={{ uri: avatar }} />
}
